import Sidebar from '../components/Sidebar'
import Header from '../components/Header'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { DerbySoftMUItheme } from "../styles/muiTheme"
import React, {useReducer} from 'react';
import { rightContentWidthContext, reducer } from './RightContentWidthContext';
import { Layout } from 'antd';
import {SideBarStatusProvider} from '../store/sidebarContext'
import {useSideBarStatus} from '../store/sidebarContext'
const theme = createMuiTheme(DerbySoftMUItheme);
interface propTypes {
    children?: React.ReactNode;
}

const MainContents = (props: propTypes) => {
    const [width, dispatch] = useReducer(reducer, 288 + 'px');
    const { Content } = Layout;
    const [subMenuStatus,setSubMenuStatus] = React.useState<boolean>(false);
    const [hasFocus,setHasFocus] = React.useState<boolean>(false);

    const handleGlobalMenu = ()=>{
        if(subMenuStatus){
            setSubMenuStatus(false)
            setHasFocus(false)
        }
    }
    return (
        <MuiThemeProvider theme={theme}>
            <rightContentWidthContext.Provider value={{ width, dispatch }}>
          
                    <Layout onClick={handleGlobalMenu} style={{ minHeight: '100vh' }}>
                        <SideBarStatusProvider>
                            <Sidebar
                                 subMenuStatus={subMenuStatus} 
                                 setSubMenuStatus={setSubMenuStatus}
                                 setHasFocus={setHasFocus}
                                 hasFocus={hasFocus}
                                 />
                            <Layout className="site-layout">
                                <Header />
                                <Content>
                                    {props.children}
                                </Content>
                            </Layout>
                        </SideBarStatusProvider>
                    </Layout>
     
            </rightContentWidthContext.Provider>
        </MuiThemeProvider>
    )
}

export default MainContents